export default "__VITE_ASSET__BnLyh0W9__"